import { SET_CURRENT_COMPANY, REMOVE_CURRENT_COMPANY } from "./types";

export const setCurrentCompany = data => {
  return {
    type: SET_CURRENT_COMPANY,
    payload: data
  };
};

export const removeCurrentCompany = data => {
  return {
    type: REMOVE_CURRENT_COMPANY
  };
};
